module.exports = __webpack_public_path__ + "images/emoji/package.2b8ecb27a48c41a34e80.png";